import {useEffect, useRef} from 'react';

/**
 * We have a recurring bug where the custom formatting function for the y-axis values can lead to values that are not unique. We want to get a better understanding of the scenarios that cause this bug so we can design a solution for it.
 *
 * https://weightsandbiases.slack.com/archives/C07JHLX0HJ5/p1744416332311149
 */
export const useYAxisObservation = ({
  chartRef,
  yAxisTickTotal,
  yDomain,
}: {
  chartRef: HTMLDivElement | null;
  yAxisTickTotal: number;
  yDomain: [number | null, number | null];
}) => {
  const hasLogged = useRef(false);

  useEffect(() => {
    if (hasLogged.current || !chartRef || yAxisTickTotal === 0) {
      return;
    }

    async function checkTicks() {
      try {
        const ticks = chartRef?.querySelectorAll(
          '.y-axis-plot .rv-xy-plot__axis__tick'
        );

        if (ticks?.length) {
          const tickValues = Array.from(ticks).map(t => t.textContent);
          const uniques = new Set(tickValues);

          if (uniques.size !== tickValues.length) {
            console.error('Vis team: duplicate tick value in chart plot', {
              yAxisTickTotal,
              tickValues,
              yDomain,
            });
            // once the chart has logged
            hasLogged.current = true;
          }
        }
      } catch (e) {
        console.error('Vis team: error checking ticks', e);
      }
    }

    checkTicks();
  }, [yAxisTickTotal, yDomain, chartRef]);
  return null;
};
